import produce, { Draft, enableES5 } from 'immer';
import { GrammarCheckSettings } from '../models/store';
import { ActionTypes } from '../models/actions';
import { HYDRATE_STORE_FROM_SESSION, SET_SETTING_VALUE } from '../models/actions/names';
import { GcSettingNames } from '../models/GrammarCheck';

enableES5();

const initState = {
  isGrammarCheckRunning: false,
};

export const settingsReducer = produce(
  (draft: Draft<GrammarCheckSettings>, action: ActionTypes) => {
    switch (action.type) {
      case SET_SETTING_VALUE:
        if (action.payload.settingName === GcSettingNames.GC_REGIONAL_LANGUAGE) {
          draft.gcRegionalLanguage = action.payload.value as string;
        } else if (action.payload.settingName === GcSettingNames.GC_FLUENCY_MODE) {
          draft.gcFluencyModeEnabled = action.payload.value as boolean;
        }
        break;

      case HYDRATE_STORE_FROM_SESSION:
        try {
          if (action.src === 'SETTINGS') {
            return { ...draft, ...action.store };
          }
          // eslint-disable-next-line no-empty
        } catch (e) {}
        break;
    }
  },
  initState
);
